import React, { createContext, useEffect, useState, useContext, Dispatch, SetStateAction } from 'react'
import { BrandDetailsType } from '../../../../server/models/BrandDetails'
import { getMyBrandDetails } from '../../../requests/brandDetails'
import { handleError } from '../../../errors/handleError'

export type SavedBrandDetailsContextType = {
  savedBrandDetails: BrandDetailsType[]
  setSavedBrandDetails: Dispatch<SetStateAction<BrandDetailsType[]>>
}

const SavedBrandDetailsContext = createContext<SavedBrandDetailsContextType | undefined>(undefined)

type Props = {
  children: React.ReactNode
}

export const SavedBrandDetailsProvider: React.FC<Props> = ({ children }) => {
  const [savedBrandDetails, setSavedBrandDetails] = useState<BrandDetailsType[]>([])

  useEffect(() => {
    const fetchBrandDetails = async () => {
      try {
        const { data } = await getMyBrandDetails()
        setSavedBrandDetails(data)
      } catch (err) {
        handleError(err, 'Failed to fetch saved brand details')
        setSavedBrandDetails([])
      }
    }

    fetchBrandDetails()
  }, [])

  return (
    <SavedBrandDetailsContext.Provider value={{ savedBrandDetails, setSavedBrandDetails }}>
      {children}
    </SavedBrandDetailsContext.Provider>
  )
}

export const useSavedBrandDetails = (): SavedBrandDetailsContextType => {
  const context = useContext(SavedBrandDetailsContext)

  if (!context) {
    throw new Error('useSavedBrandDetails must be used within an SavedBrandDetailsProvider')
  }

  return context
}
